import { BaseError } from './BaseError.js';
import type { ClientErrorCode } from './constants.js';

export class CollectionError extends Error {
  private readonly _errors: (BaseError<ClientErrorCode> | Error)[] = [];

  constructor() {
    super();
    this.name = 'CollectionError';
  }

  get errors(): (BaseError<ClientErrorCode> | Error)[] {
    return this._errors;
  }

  override get message(): string {
    return JSON.stringify(this.toJSON());
  }

  addError(...error: (BaseError<ClientErrorCode> | Error)[]): void {
    this._errors.push(...error);
  }

  getFirstBaseError(): BaseError<ClientErrorCode> | undefined {
    for (const error of this._errors) {
      if (error instanceof BaseError) {
        return error;
      }
    }

    return undefined;
  }

  /**
   * Returns a JSON representation of the error
   * Should only be used for logging purposes.
   *
   * @returns JSON representation of all errors
   */
  toJSON(): { message: string; clientCode: ClientErrorCode }[] {
    return this._errors.map((err) => {
      if (err instanceof BaseError) {
        return err.toJSON();
      }

      return { message: err.message, clientCode: 'GENERIC' };
    });
  }

  override toString(): string {
    return JSON.stringify(this.toJSON());
  }
}
